import useCountryConfigHook from "./useCountryConfigHook";

const useVatHook = () => {
  const { vats } = useCountryConfigHook();

  return { vats };
};

export default useVatHook;
